import { OdataManager } from '@/api/odata/odata-manager';
import { RegisterIssueCommentAttachment } from '@/api/model/interfaces';

export default class RegisterIssueCommentAttachmentOdata extends OdataManager<RegisterIssueCommentAttachment> {}
